<div class="card">
  <div class="card-body">
    <h5 class="card-title">Usage Events</h5>
    <h2><h6 class="text-muted mb-0">Total</h6>{{total}}</h2>
    <load-spinner [show]="chartOptions == undefined" [inner]="true"></load-spinner>
    <div *ngIf="chartOptions != undefined">
      <highcharts-chart 
        [Highcharts]="Highcharts"
        [options]="chartOptions"
        style="width: 100%; height: 400px; display: block;"
      >
      </highcharts-chart>
    </div>
    <h6 *ngIf="chartOptions != undefined" class="card-subtitle mt-2 text-muted">Reported Month: {{lastUpdated}}</h6>
  </div>
</div>